import React, {useEffect, useState} from "react"
import {apiGetDashboard} from "./Actions";
import TableData from "./TableData";
import {EnigooLoader} from "../../components/My/EnigooLoader";
import {useSelector} from "react-redux";

const Dashboard = () => {

    let [loading, setLoading] = useState(false)
    let [data, setData] = useState(null)
    let user = useSelector((state) => state.user)


    useEffect(() => {
        get()
    }, [])

    const get = () => {
        apiGetDashboard((response) => {
           setData(response)
           setLoading(false)
        }, error => {
            setData([])
            setLoading(false)
        })
    }

    if (loading) return <EnigooLoader/>
    if (!data) return null

    const getBody = () => {
        if (user?.user?.rights?.dashboard) {
            return <TableData data={data}/>
        } else {
            return (
                <div className={"justify-center items-center flex flex-col text-center"}>
                    <h4>Aplikace Turnikety ENIGOO</h4>
                    <div className={"text-base"}>Pro pokračování vyberte položku v levém menu.</div>
                </div>
            )
        }
    }

    return getBody()

}

export default Dashboard
